// extracted by mini-css-extract-plugin
export default {"container":"Valuations_container__shjSK","buttonWrapper":"Valuations_buttonWrapper__7c5Vu"};